var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0367 9.75209C14.0304 9.53237 13.9488 9.34403 13.7793 9.17453L8.89509 4.39704C8.7507 4.25893 8.58119 4.18359 8.37402 4.18359C7.9534 4.18359 7.62695 4.51004 7.62695 4.93066C7.62695 5.13156 7.70857 5.31989 7.85296 5.46429L12.2475 9.75209L7.85296 14.0399C7.70857 14.1843 7.62695 14.3664 7.62695 14.5735C7.62695 14.9941 7.9534 15.3206 8.37402 15.3206C8.57492 15.3206 8.7507 15.2453 8.89509 15.1071L13.7793 10.3234C13.9551 10.1602 14.0367 9.97182 14.0367 9.75209Z",
    fill: "#8592A3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/RightArrow.2e244a1904b91f9be4d145461ba3283d.svg";
export { ForwardRef as ReactComponent };